import api from "@/services/api"
import { queryClient } from "@/queryClient"
import type { CardTransactionData } from "@/androidPlugins/IPayment"
import type { RecursivelyConvertDatesToStrings } from "@/utils/typeUtilities"

import {
  BASE_ORDERS_QUERY_KEY,
  BASE_TRANSACTIONS_QUERY_KEY,
} from "./queryKeys"
import type {
  TRANSACTION_TYPE,
  TransactionMethod,
  TransactionStatus,
} from "./sharedTypes/transactions"

type CashRefundIn = {
  source: "pos_cash"
  data: {
    amount: number
  }
}

type CardRefundIn = {
  source: "pos_card"
  data: CardTransactionData
}

export type CreateRefundResponse = {
  id: string
  createdAt: Date
  type: (typeof TRANSACTION_TYPE)["REFUND"]
  invoiceId: string
  parentTransactionId: string | null
  amountTransactedGross: number
  amountTransactedGratuity: number
  amountTransactedTotal: number
  currency: string
  status: TransactionStatus
  transactionMethod: TransactionMethod | null
  uti: string | null
  deviceSerialNumber: string | null
}

export const createRefund = async (
  transactionid: string,
  payload: CashRefundIn | CardRefundIn
): Promise<CreateRefundResponse> => {
  const { body } = await api.post<
    RecursivelyConvertDatesToStrings<CreateRefundResponse>
  >(`/transactions/${transactionid}/refunds/`, {
    body: payload,
  })

  queryClient.invalidateQueries({
    queryKey: [BASE_ORDERS_QUERY_KEY],
  })
  queryClient.invalidateQueries({
    queryKey: [BASE_TRANSACTIONS_QUERY_KEY],
  })

  return {
    ...body,
    createdAt: DateFns.parseISO(body.createdAt),
  }
}
